import React, { useState, useEffect } from "react";
import axios from 'axios';
import FsLightbox from "fslightbox-react";
import Sectiontitle from "../components/Sectiontitle";
import Layout from "../components/Layout";
import Service from '../components/Service';
import Resume from "../components/Resume";

function About(){
  const [toggler, setToggler] = useState(false);
  const [information, setInformation] = useState([]);
  const [services, setServices] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [roadmap1, setRoadmap1] = useState([]);
  const [roadmap2, setRoadmap2] = useState([]);

  const sliderSettings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  };

  const handleToggler = (event) => {
    setToggler({
      toggler: event
    })
  }

  useEffect(() =>{
    axios.get('/api/information')
      .then(response =>{
        setInformation(response.data)
      })
    axios.get('/api/services')
      .then(response =>{
        setServices(response.data)
      })
    axios.get('/api/reviews')
      .then(response =>{
        setReviews(response.data)
      })
    axios.get('/api/experience')
      .then(response =>{
        setRoadmap1(response.data.roadmap1.reverse());
        setRoadmap2(response.data.roadmap2.reverse());
      })
  }, [])

  return (
    <Layout>
      <div className="mi-about-area mi-section mi-padding-top">
        <div className="container">
          <Sectiontitle title="회사소개" subTitle="About Us"/>
          <div className="row">
            <div className="col-lg-6">
              <div className="mi-about-image">
                <img
                  src={information.aboutImage}
                  alt="about"
                />
                <FsLightbox
                  toggler={toggler}
                  sources={[information.aboutImageLg]}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mi-about-content">
                <h3>
                  <span className="color-theme">MayQueen Pictures</span>
                </h3>
                <ul>
                  {!information.name ? null : <li>
                    <b>회사명</b> (주){information.name}
                  </li>}
                  <li>
                    <b>설립일</b> 2011년 11월 18일 (2006년 1월 마이더스픽쳐스 설립)
                  </li>
                  <li>
                    <b>대표이사</b> 김 진 천
                  </li>
                  <li>
                    <b>자본금</b> 금 2,000백만원 (총4,000,000주, 액면가 500원)
                  </li>
                  <li>
                    <b>사업 분야</b> TV, 케이블 방송 드라마 제작
                  </li>
                  <li>
                    <b>대표 작품</b> 메이퀸(2012, MBC), 황금무지개(2013, MBC), 빛나거나 미치거나(2015, MBC), 화려한 유혹(2015, MBC)
                  </li>
                  <li>
                    <b>회사 소개지</b> 서울시 성동구 성수일로 45 (성수동1가, 메이퀸픽쳐스빌딩)
                  </li>
                  <li>
                    <b>홈페이지</b> mqpictures.com
                  </li>
                  <li>
                    <b>임직원 수</b> 11 명
                  </li>
                </ul>
                {/* <a href={information.cvfile} className="mi-button">Download CV</a> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mi-resume-area mi-section mi-padding-top mi-padding-bottom">
        <div className="container">
          <Sectiontitle title="연혁" subTitle="Road Map"/>
          {/* <Smalltitle title="Working Experience" icon="briefcase" /> */}
          <div className="container row">
            <div className="col-lg-6 col-md-12">
          <div className="mi-resume-wrapper">
            {roadmap2.map(roadmapTwo => (
              <Resume key={roadmapTwo.id} resumeData={roadmapTwo}/>
            ))}
          </div>
          </div>          
          <div className="col-lg-6 col-md-12">
          <div className="mi-resume-wrapper">
            {roadmap1.map(roadmapOne => (
              <Resume key={roadmapOne.id} resumeData={roadmapOne} />
            ))}
          </div>
          </div>
          </div>
        </div>
      </div>


      <div className="mi-service-area mi-section mi-padding-top">
        <div className="container">
          <Sectiontitle title="주요 구성원" subTitle="Team" />
          <div className="mi-service-wrapper">
            <div className="row mt-30-reverse">
              {services.map(service => (
                <div className="col-lg-4 col-md-6 col-12 mt-30" key={service.title}>
                  <Service content={service}/>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

    </Layout>
  );
}

export default About;
